import { x64 } from "crypto-js";

function tabthIsEqual(arr1, arr2) {
    let colNameList1 = arr1.map(item => item.colname)
    let colNameList2 = arr2.map(item => item.colname)
    return colNameList1.toString() == colNameList2.toString()
}
export default () => ({
    data() {
        return {};
    },
    watch: {
    },
    created() {
        if (this.$router.currentRoute.params.tableName === 'CP_C_CUSTOMER_REPORT') {
            this.clearHideColumn(249130562)
        }
        if (this.$router.currentRoute.params.tableName === 'CP_C_STORE_REPORT') {
            this.clearHideColumn(249130559)
        }
        this.lastTabth = []
    },
    updated() {
        //客户档案报表
        if (window.customerReportAgtableTabth && this.$router.currentRoute.params.tableName === 'CP_C_CUSTOMER_REPORT' && this.ag.datas && this.ag.datas.tabth) {
            // console.log('old :>> ', this.ag.datas.tabth);
            // console.log('old :>> ', this.lastTabth);
            // console.log('new :>> ', window.customerReportAgtableTabth);
            if (!tabthIsEqual(this.lastTabth, window.customerReportAgtableTabth)) {
                console.log('客户档案报表 更新table数据');
                this.lastTabth = window.customerReportAgtableTabth
                let tableData = this.ag.datas
                // this.ag.datas.tabth = window.customerReportAgtableTabth
                // console.log('update.customerReportAgtableTabth :>> ', window.customerReportAgtableTabth);
                // tableData.tabth = window.customerReportAgtableTabth
                this.updateTableData(tableData)

                // this.setHideColumn(window.customerReportHideColumn, 249130562)
                if (window.extraCustomerReportHideColumn) {
                    window.customerReportHideColumn && this.onColumnVisibleChanged(`${window.customerReportHideColumn},${window.extraCustomerReportHideColumn}`)
                } else {
                    window.customerReportHideColumn && this.onColumnVisibleChanged(window.customerReportHideColumn)
                }
            }
        }
        //店铺档案报表
        if (window.storeReportAgtableTabth && this.$router.currentRoute.params.tableName === 'CP_C_STORE_REPORT' && this.ag.datas && this.ag.datas.tabth) {
            // console.log('old.tabth :>> ', this.lastTabth);
            // console.log('new.storeReportAgtableTabth :>> ', window.storeReportAgtableTabth);
            if (!tabthIsEqual(this.lastTabth, window.storeReportAgtableTabth)) {
                console.log('店铺档案报表 updateTableData');
                this.lastTabth = window.storeReportAgtableTabth

                let tableData = this.ag.datas
                // tableData.tabth = window.storeReportAgtableTabth
                this.updateTableData(tableData)

                // this.setHideColumn(window.storeReportHideColumn, 249130559)
                if (window.extraStoreReportHideColumn) {
                    window.storeReportHideColumn && this.onColumnVisibleChanged(`${window.storeReportHideColumn},${window.extraStoreReportHideColumn}`)
                } else {
                    window.storeReportHideColumn && this.onColumnVisibleChanged(window.storeReportHideColumn)
                }
            }
        }
    },
    mounted() {
    },
    methods: {
        clearHideColumn(tableid) {
            console.log('standardTableListsCustomize created call clearHideColumn');
            let formdata = new FormData();
            formdata.append('tableid', tableid);
            formdata.append('hidecolumns', '');
            return this.$network.post("/p/cs/setHideColumn", formdata)
            // .then((res) => {
            //     // console.log('setHideColumn.res :>> ', res.data.data);
            // });
        },
        setHideColumn(hidecolumns, tableid) {
            // console.log('hidecolumns :>> ', hidecolumns);
            let formdata = new FormData();
            formdata.append('tableid', tableid);
            formdata.append('hidecolumns', hidecolumns || '');
            this.$network.post("/p/cs/setHideColumn", formdata)
                .then((res) => {
                    // console.log('setHideColumn.res :>> ', res.data.data);
                });
        },
        R3_processAgOptions(options) {
            //客户档案报表
            if (this.$router.currentRoute.params.tableName === 'CP_C_CUSTOMER_REPORT') {
                // console.log('options :>> ', options);
                options.datas.hideColumn = `${window.customerReportHideColumn}${window.extraCustomerReportHideColumn ? ',' + window.extraCustomerReportHideColumn : ''}`
                let timer = null
                options.onColumnVisible = (params) => {
                    timer && clearTimeout(timer)
                    timer = setTimeout(() => {
                        let hideColumns = []
                        params.columnApi.getColumnState().forEach((d) => {
                            if (d.hide) {
                                hideColumns.push(d.colId)
                            }
                        })
                        // hideColumns = hideColumns.toString()
                        window.extraCustomerReportHideColumn = hideColumns
                        // 调用r3内部隐藏列回调
                        // console.log('R3_processAgOptions :>> ', `${window.customerReportHideColumn},${hideColumns}`);
                        this.onColumnVisibleChanged(`${window.customerReportHideColumn},${hideColumns}`)
                    }, 10)
                }
            }
            //店铺档案报表
            if (this.$router.currentRoute.params.tableName === 'CP_C_STORE_REPORT') {
                options.datas.hideColumn = `${window.storeReportHideColumn}${window.extraStoreReportHideColumn ? ',' + window.extraStoreReportHideColumn : ''}`
                let timer = null
                options.onColumnVisible = (params) => {
                    timer && clearTimeout(timer)
                    timer = setTimeout(() => {
                        let hideColumns = []
                        params.columnApi.getColumnState().forEach((d) => {
                            if (d.hide) {
                                hideColumns.push(d.colId)
                            }
                        })
                        // hideColumns = hideColumns.toString()
                        window.extraStoreReportHideColumn = hideColumns
                        // 调用r3内部隐藏列回调
                        this.onColumnVisibleChanged(`${window.storeReportHideColumn},${hideColumns}`)
                    }, 10)
                }
            }
            return options
        },
        // 处理列表界面的表格
        R3_processColumns(columns) {
            columns.forEach(item => {
                // var box = /^[\u4e00-\u9fa5]+$/;
                // box.test("中文")//返回 true
                item.tdAlign = 'left' // 列的表体内容居中
            })
            if (this.$router.currentRoute.params.tableName === 'CP_C_CUSTOMER_REPORT') {
                // const hideColumn = `${window.customerReportHideColumn}${window.extraCustomerReportHideColumn ? ',' + window.extraCustomerReportHideColumn : ''}`
                // let hideColumnList = hideColumn.split(',')

                let hideColumnList = window.customerReportHideColumn.split(',')
                const tempArr = columns.filter(item => !hideColumnList.includes(item.colname))
                columns.length = 0
                columns.push(...tempArr)
                // console.log("🚀 ~ file: standardTableListsCustomize.js ~ line 139 ~ R3_processColumns ~ columns", columns)
            }
            if (this.$router.currentRoute.params.tableName === 'CP_C_STORE_REPORT') {
                // const hideColumn = `${window.storeReportHideColumn}${window.extraStoreReportHideColumn ? ',' + window.extraStoreReportHideColumn : ''}`
                // let hideColumnList = hideColumn.split(',')

                let hideColumnList = window.storeReportHideColumn.split(',')
                const tempArr = columns.filter(item => !hideColumnList.includes(item.colname))
                columns.length = 0
                columns.push(...tempArr)
                // console.log("🚀 ~ file: standardTableListsCustomize.js ~ line 139 ~ R3_processColumns ~ columns", columns)
            }
            return columns
        },
    },
});